import settings from '@/constants/constants';
import { FF_ENABLE_EXTERNAL_IN_TOKEN } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import useCustomer from '@/hooks/user/useCustomer';
import useGetZendeskToken from '@/hooks/zendesk/useGetZendeskToken';
import { UMedsChatbot } from '@montugroup/chatbots';
import getAuthBearerToken from '@montugroup/circuit-shared/utils/getAuthBearerToken';

interface ChatbotWidgetProps {
  anonymous?: boolean;
  bottomOffset?: number;
}

export function ChatbotWidget({ anonymous, ...props }: ChatbotWidgetProps) {
  if (anonymous) {
    return <UnauthenticatedWidget {...props} />;
  }

  return <AuthenticatedWidget {...props} />;
}

function UnauthenticatedWidget({ bottomOffset }: ChatbotWidgetProps) {
  return <UMedsChatbot apiKey={settings.chatbotApiKey} shadow={true} bottomOffset={bottomOffset} />;
}

function AuthenticatedWidget({ bottomOffset }: ChatbotWidgetProps) {
  const token = getAuthBearerToken();
  const { flags } = useFeatureFlags();
  const { data } = useGetZendeskToken();
  const { data: customer } = useCustomer();
  const customerId = customer?.id;
  const isCustomerTypeEnabled = flags[FF_ENABLE_EXTERNAL_IN_TOKEN];
  const zendeskToken = data?.token;

  return (
    <UMedsChatbot
      apiKey={settings.chatbotApiKey}
      token={token}
      zendeskToken={zendeskToken}
      customerId={customerId}
      customerType={isCustomerTypeEnabled ? (customer?.isExternal ? 'external' : 'internal') : undefined}
      shadow={true}
      bottomOffset={bottomOffset}
      questionOverrides={['Where is my order?', 'What are my active orders?', 'How do I cancel my order?']}
    />
  );
}
